<template>
  <div>
    <div class="content7 flex flex-column flex-justify-center flex-align-center" ref="content7">
      <h1 v-html="$t('connect.join')"></h1>
      <div class="btn" @click="toConnect">{{ $t('connect.try') }}</div>
      <div class="btn1 flex flex-justify-center flex-align-center" @click="openRandomLink()">
        {{ $t('connect.contact') }}
        <img src="@/assets/image/Slice 21@3x.png" />
      </div>
    </div>
    <div class="content8 flex flex-column flex-justify-center flex-align-center" data-aos="fade" ref="content8" v-if="formStatus">
      <h1>{{ $t('connect.exchange') }}</h1>
      <h2>{{ $t('connect.try') }}</h2>

      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-row>
          <el-col :span="11">
            <el-form-item :label="$t('connect.form.name')" prop="name">
              <el-input v-model="form.name" :placeholder="$t('connect.form.namePlaceholder')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="1">
            <el-form-item :label="$t('connect.form.email')" prop="email">
              <el-input v-model="form.email" :placeholder="$t('connect.form.emailPlaceholder')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item :label="$t('connect.form.surname')" prop="surname">
              <el-input v-model="form.surname" :placeholder="$t('connect.form.surnamePlaceholder')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11" :offset="1">
            <el-form-item :label="$t('connect.form.company')" prop="companyName">
              <el-input v-model="form.companyName" :placeholder="$t('connect.form.companyPlaceholder')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('connect.form.telegram')" prop="telegram">
              <el-input v-model="form.telegram" :placeholder="$t('connect.form.telegramPlaceholder')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="btn" @click="submitEvent">{{ $t('connect.form.submit') }}</div>
      </el-form>
    </div>
  </div>
</template>
<script>
import {openRandomLink} from '@/utils'
export default {
  data () {
    return {
      form: {},
      formStatus:false,
      googleFormUrl: 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSdrTp1iC2oGyV6gwjybS2gIB8cpU69mB5WaWd5Qx30gclB5Ew/formResponse'
    }
  },
  computed: {
    rules () {
      return {
        name: [
          { required: true, message: this.$t('connect.form.validName'), trigger: 'blur' },
        ],
        email: [
          { required: true, message: this.$t('connect.form.validEmail'), trigger: 'blur' },
          { type: 'email', message: this.$t('connect.form.validEmailFormat'), trigger: ['blur', 'change'] },
        ],
        surname: [
          { required: true, message: this.$t('connect.form.validSurname'), trigger: 'blur' },
        ],
        companyName: [
          { required: true, message: this.$t('connect.form.validCompany'), trigger: 'blur' },
        ],
        telegram: [
          { required: true, message: this.$t('connect.form.validTelegram'), trigger: 'blur' },
        ],
      }
    }
  },
  methods: {
    openRandomLink: openRandomLink,
    submitEvent () {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
            const formData = new FormData();
            // 将用户输入映射到 Google 表单字段
            formData.append('entry.1021103268', this.form.name);
            formData.append('entry.1421088669', this.form.email);
            formData.append('entry.2129883738', this.form.surname);
            formData.append('entry.1993816064', this.form.companyName);
            formData.append('entry.228762629', this.form.telegram);

          try {
            await fetch(this.googleFormUrl, {
              method: 'POST',
              mode: 'no-cors', // 必须使用 no-cors 模式
              body: formData,
            });
            this.$message({type: 'success',message: this.$t('connect.form.success')});
            this.$refs.ruleForm.resetFields();
            this.formStatus = false
          } catch (error) {
            console.error('Form submission failed:', error);
            alert(this.$t('connect.form.error'));
          }
         
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    toConnect () {
      this.formStatus = true
      setTimeout(() => {
        const target = this.$refs.content8;
        target.scrollIntoView({
          behavior: 'smooth', // 使用平滑滚动
          block: 'start' // 滚动到目标元素的顶部
        });
      }, 300);
    },
    toConnectIndex() {
      setTimeout(() => {
        const target = this.$refs.content7;
        target.scrollIntoView({
          behavior: 'smooth', // 使用平滑滚动
          block: 'start' // 滚动到目标元素的顶部
        });
      }, 300)
    }
  }
}
</script>
<style lang="less" scoped>
.content7 {
  height: 684px;
  background: url('@/assets/image/Slice 22@2x (1).png') no-repeat center/100% 100%;

  h1 {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 60px;
    color: rgba(0, 0, 0, 0);
    line-height: 67px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    background: linear-gradient(35.26439014500239deg, #FFFFFF 30%, rgba(255, 255, 255, 0.5) 100%);
    -webkit-background-clip: text;
    /* 裁剪背景到文字形状 */
    -webkit-text-fill-color: transparent;
    /* 文字填充透明，显示背景 */
  }

  .btn {
    width: 433px;
    height: 185px;
    background: url('@/assets/image/Slice 20@3x.png') no-repeat center/100% 100%;
    padding-top: 22px;
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 28px;
    letter-spacing: 5px;
    text-align: center;
    margin: 8px auto 5px;
    cursor: pointer;
  }

  .btn1 {
    width: 223px;
    height: 51px;
    border: 1px solid;
    font-family: JetBrains Mono, JetBrains Mono;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 5px;
    border-radius: 8px 8px 8px 8px;
    cursor: pointer;
    img {
      width: 26px;
      height: 21px;
    }
  }
}

.content8 {
  height: 1294px;
  background: url('@/assets/image/Slice 22@2x (1).png') no-repeat center/100% 100%;

  h1 {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 60px;
    color: rgba(0, 0, 0, 0);
    line-height: 67px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    background: linear-gradient(35.26439014500239deg, #FFFFFF 30%, rgba(255, 255, 255, 0.5) 100%);
    -webkit-background-clip: text;
    /* 裁剪背景到文字形状 */
    -webkit-text-fill-color: transparent;
    /* 文字填充透明，显示背景 */
  }

  h2 {
    font-family: Inter, Inter;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 28px;
    letter-spacing: 14px;
    margin: 30px auto 79px;
  }

  .el-form {
    width: 968px;
    background: #FFFFFF;
    box-shadow: 0px 17px 44px 0px rgba(179, 179, 179, 0.25);
    border-radius: 40px 40px 40px 40px;
    padding: 57px 59px;
    font-size: 20px;

    .el-form-item {
      margin-bottom: 52px;

      ::v-deep .el-input__inner {
        height: 80px;
        border-radius: 20px;
        line-height: 80px;
        font-size: 20px;
      }

      ::v-deep .el-form-item__label {
        font-size: 20px;
      }

      ::v-deep .el-form-item__error {
        font-size: 20px;
      }
    }
  }

  .btn {
    width: 588px;
    height: 69px;
    line-height: 69px;
    background: linear-gradient(90deg, #D22E9B 0%, #9951F3 39%, #513EBF 100%);
    border-radius: 60px 60px 60px 60px;
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 22px;
    color: #FFFFFF;
    text-align: center;
    margin: 0 auto;
    cursor: pointer;
  }
}
</style>